import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"color":"#fff","text-align":"center","font-size":"24px","margin":"36px auto 48px"} }, " Statistics for oswap.io ", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"max-width":"1200px","width":"90%","margin":"16px auto","padding":"0 16px"} }

import { inject, computed, ComputedRef, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Obyte from "@/obyte";
import Pool from "@/helpers/PoolHelper";
import { ITickers } from "@/interfaces/tickers.interface";
import Menu from "@/components/Menu.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const Client = inject("Obyte") as Obyte.Client;
const store = useStore();
const router = useRouter();

store.dispatch("initIfNotInit", Client);

const poolsData = computed(() => store.state.poolsData);
const tickers: ComputedRef<ITickers> = computed(() => store.state.tickers);
const isReady = computed(() => store.state.ready);

const customRow = (pool: { pool: { address: string } }) => {
  return {
    onClick: () => {
      router.push({
        name: "Pool",
        params: {
          address: pool.pool.address,
        },
      });
    },
  };
};

const columns = ref([
  {
    title: "#",
    dataIndex: "n",
    key: "n",
  },
  {
    title: "Pool",
    dataIndex: "pool",
    key: "pool",
    slots: { customRender: "pool" },
  },
  {
    title: "TVL",
    dataIndex: "TVL",
    key: "tvl",
  },
  {
    title: "Volume 24H",
    dataIndex: "volume",
    key: "volume",
  },
]);

const data = computed(() => {
  return poolsData.value.pools.map((pool: Pool, index: number) => {
    return {
      key: pool.ticker,
      n: index + 1,
      pool: {
        name: pool.ticker,
        fee: pool.swapFee / 1000000000,
        address: pool.address,
      },
      TVL: "$" + pool.marketcap.toFixed(2),
      volume:
        "$" +
        pool.get24hVolumeInUSD(
          tickers.value,
          poolsData.value.assets,
          Client.exchangeRates
        ),
    };
  });
});

return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Menu),
    _hoisted_1,
    (_unref(isReady))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_table, {
              class: "table",
              dataSource: _unref(data),
              columns: columns.value,
              "custom-row": customRow,
              rowClassName: (record, index) => 'table-pointer'
            }, {
              pool: _withCtx(({ text: objPool }) => [
                _createTextVNode(_toDisplayString(objPool.name) + " ", 1),
                _createVNode(_component_a_tag, {
                  class: "fee",
                  style: {"margin-left":"8px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(objPool.fee) + "%", 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }, 8, ["dataSource", "columns", "rowClassName"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})